import Vue from 'vue';
import { beforeRouteEnter } from '@assets/js/routerPageHook.js';
import filterContainer from '@components/ui-components/filter-container/filter-container.vue';
import LoadMore from '@components/ui-components/load-more/load-more';
import onScrollAnimate from '@assets/js/scrollAnimate.js';
import VideoBlock from '@components/ui-components/video-block/component.js';
import formGreen from '@components/base/form-green.vue';
import {router} from "@src/routes";

export default {
    name: 'index',
    data() {
        return {
            template: '<main></main>',
            newVacancies: [],
            pagination: null,
            disableLoadMore: false,
        };
    },
    components: {
        'filter-container-cmp': filterContainer,
        'load-more-cmp': LoadMore,
        'video-block-cmp': VideoBlock,
        'form-green-cmp': formGreen,
    },
    methods: {
        setPagination() {
            setTimeout(() => {
                this.pagination = this.$root.convertTwigToJs(
                    'pagination',
                    '.js-pagination'
                );
            }, 100);
        },
        linkTo(link) {
            window.open(link, '_blank');
        },
    },
    mounted() {
        this.setPagination();
    },
    beforeRouteUpdate(to, from, next) {
        // если не loadMore
        if (!to.query.loadMore) {
            const path = to.path.replace(router.history.base, '');
            this.$root.setDataAnimateFalse();

            Vue.http.get(`templates${path}`, { params: to.query }).then(
                (data) => {
                    next();
                    setTimeout(() => {
                        this.template = data.data;
                        this.newVacancies = [];
                        this.setPagination();
                    }, 500);
                },
                () => {
                    next('/404');
                }
            );
        } else {
            this.disableLoadMore = true;
            let url = process.env.NODE_ENV !== 'production' ?
                'career/index.json' :
                to.path.substring(1).replace(router.history.base, '');

            Vue.http.get(url, { params: to.query }).then(
                (data) => {
                    next();
                    this.newVacancies = this.newVacancies.concat(data.data.items);
                    this.pagination = data.data.pagination;
                    this.disableLoadMore = false;
                    setTimeout(() => {
                        onScrollAnimate();
                    }, 10);
                },
                () => {
                    this.disableLoadMore = false;
                    next('/404');
                }
            );
        }
    },
    beforeRouteEnter,
    render(createElement) {
        return Vue.compile(this.template).render.call(this, createElement);
    },
};



// WEBPACK FOOTER //
// ./src/templates/pages/career/index.js